export default {
  create: {
    success: 'Source crééé avec succès',
    error: 'Impossible de créer la source'
  },
  update: {
    success: 'Modification de la source effectuée avec succès',
    error: 'Impossible de modifier la source'
  },
  delete: {
    success: 'Source supprimée avec succès',
    error: 'Impossible de supprimer la source'
  },
  import: {
    success: 'Importation des sources effectuée',
    error: "Impossible d'importer les sources"
  }
}
